import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Alert, TextField } from "@curves/ui-base";
import { formatCurrencyFn, getErrorModuleStatus, refIsRequiredError } from '@util/utils';
import clsx from 'clsx';
import { PaidList } from '@icoach/documents/components';
import { PaidListLayout } from '@icoach/documents/components/PaidList';

const CheckoutPaidListBox = React.forwardRef((props, ref) => {
    const { className, receivableAmount = 0, paidPrice = 0, errorModule = {} } = props;
    const [paymentInfo, setPaymentInfo] = useState({
        paymentAmount: 0,
        balanceAmount: receivableAmount,
    });
    const cashRef = useRef();
    const cardRef = useRef();
    const walletRef = useRef();

    const calculateBalance = () => {
        let cash = Number(cashRef.current.getResult()) || 0;
        let card = Number(cardRef.current.getResult()) || 0;
        let balanceAmount = 0;
        let paymentAmount = 0;
        if (typeof paidPrice === 'number') {
            paymentAmount += paidPrice;
        }
        paymentAmount += cash;
        paymentAmount += card;
        if (typeof receivableAmount === 'number') {
            balanceAmount = receivableAmount - paymentAmount;
        }
        setPaymentInfo({ paymentAmount, balanceAmount });
    };

    useImperativeHandle(
        ref,
        () => ({
            getResult: () => ({
                cashPayment: cashRef.current && cashRef.current.getResult(),
                cardPayment: cashRef.current && cardRef.current.getResult(),
                walletPayment: 0, // 暫時不開發，但需要給後端對應的欄位為零
            }),
            isError: () => {
                let isError = refIsRequiredError(cashRef, cardRef, walletRef);
                if (!isError) {
                    isError = paymentInfo.balanceAmount < 0;
                }
                return isError;
            },
        }),
        // eslint-disable-next-line
        [paymentInfo],
    );

    useEffect(() => {
        calculateBalance();
        // eslint-disable-next-line
    }, [paidPrice, receivableAmount]);
    return (
        <PaidListLayout className={clsx('checkout-box', className)}>
            <PaidList.PaidListGroup>
                <PaidList.PaidListItem label={'應收金額'}>
                    <strong>{formatCurrencyFn(receivableAmount)}</strong>
                </PaidList.PaidListItem>
                <PaidList.PaidListItem label={'收款金額'}>
                    <strong>{formatCurrencyFn(paymentInfo.paymentAmount)}</strong>
                </PaidList.PaidListItem>
                <PaidList.PaidListItem
                    className={clsx('paid-list-item ', {
                        'text-error': paymentInfo.balanceAmount !== 0,
                    })}
                    label={'未收金額'}
                >
                    <strong>{formatCurrencyFn(paymentInfo.balanceAmount)}</strong>
                </PaidList.PaidListItem>
                {paymentInfo.balanceAmount < 0 && (
                    <Alert severity="error" variant="filled" color="error" className="my-3">
                        收款金額已超過應收金額，無法進行結帳。
                    </Alert>
                )}
            </PaidList.PaidListGroup>
            <PaidList.PaidListGroup>
                <PaidList.PaidListItem label="現金收款金額">
                    <TextField
                        maskType={'MONEY'}
                        ref={cashRef}
                        onChangeNative={calculateBalance}
                        inputProps={{ placeholder: '請輸入金額', min: 0, required: true }}
                        {...getErrorModuleStatus(errorModule, 'cashPayment')}
                    />
                </PaidList.PaidListItem>
                <PaidList.PaidListItem label="信用卡收款金額">
                    <TextField
                        maskType={'MONEY'}
                        ref={cardRef}
                        onChangeNative={calculateBalance}
                        inputProps={{ placeholder: '請輸入金額', min: 0, required: true }}
                        {...getErrorModuleStatus(errorModule, 'cardPayment')}
                    />
                </PaidList.PaidListItem>
            </PaidList.PaidListGroup>
        </PaidListLayout>
    );
});

export default CheckoutPaidListBox;
